module.exports = __webpack_public_path__ + "img/aboutUsXzlImg.b1ce7c1a.png";